import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe, StripeElementLocale, StripeCardElement } from '@stripe/stripe-js';

@Component({
  name: 'bpc-stripe-card',
  components: {},
})
export default class StripeCard extends Vue {
  declare $refs: {
    card: HTMLElement;
  };
  @Prop({ type: Number, default: 0 }) readonly payAmount: number;
  @Prop({ type: String, default: 'card' }) readonly paymentMethodType: string;
  @Prop(Number) readonly invoiceId: number;

  protected stripe: Stripe;
  protected card: StripeCardElement;
  cardName: string = null;

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get createPaymentIntentUrl() {
    return `${this.$bpcApiRouteHelper.getEntityPath('payment')}/stripe/create-payment-intent`;
  }

  get customerPaymentName() {
    return this.$store.getters['auth/userName']
      ? this.$store.getters['auth/userName']
      : this.cardName;
  }

  get isLoggedIn() {
    return this.$authService.isLoggedIn();
  }

  /* Lifecycle hooks */
  async mounted() {
    const publicKey = this.$store.getters['centerSettings/stripePublicKey'];
    this.stripe = await loadStripe(publicKey);
    this.card = this.stripe
      .elements({ locale: this.lang as StripeElementLocale })
      .create('card', { hidePostalCode: true }); // We can pass a style object too
    this.card.mount(this.$refs.card);
    this.$emit('on-stripe-card-loaded');
  }

  /* Methods */
  async purchase() {
    // THE ERROR EMITS HERE SHOULD BE CHANGED FOR WARNING EMITS
    return new Promise((resolve, reject) => {
      if (this.customerPaymentName) {
        this.stripe
          .createToken(this.card)
          .then(result => {
            if (result.error) {
              this.$emit('on-warning-payment', result.error);
              reject(result.error);
            } else {
              this.createPaymentIntent(result.token.id);
              resolve(result);
            }
          })
          .catch(error => {
            this.$emit('on-warning-payment', error);
            reject(error);
          });
      } else {
        const error = {
          code: 'missing_card_name',
          type: 'validation_error',
          message: 'global.card_name_required',
        };
        this.$emit('on-warning-payment', error);
        reject(error);
      }
    });
  }

  async createPaymentIntent(transactionToken) {
    return new Promise((resolve, reject) => {
      const paymentData = {
        amount: this.payAmount,
        paymentMethodTypes: this.paymentMethodType,
        token: transactionToken,
        invoiceId: this.invoiceId,
      };

      this.$bpcApi.post(this.createPaymentIntentUrl, paymentData, {}, 'public').subscribe(
        res => {
          this.confirmPaymentIntent(res.data.clientSecret);
          resolve(res);
        },
        error => {
          this.$emit('on-error-payment', error);
          reject(error);
        },
      );
    });
  }

  // Calls stripe.confirmCardPayment
  // If the card requires authentication Stripe shows a pop-up modal to
  // prompt the user to enter authentication details without leaving your page.
  confirmPaymentIntent(clientSecret) {
    this.stripe
      .confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: {
            name: this.customerPaymentName,
          },
        },
      })
      .then(result => {
        if (result.error) {
          this.$emit('on-error-payment', result.error);
        } else {
          console.log('success ', result);
          this.$emit('on-success-payment', result.paymentIntent);
        }
      });
  }
}
